import styled from '@emotion/styled';
import ReactMarkdown from 'react-markdown';
import { Icon } from 'semantic-ui-react';

const Wrapper = styled.div`
	margin: 0 16px;
`;

const ExternalIcon = styled(Icon)`
	font-size: 80% !important;
	padding-left: 3px !important;
`;

type DescriptionProps = {
	children: string;
};

export const Description: React.FC<DescriptionProps> = ({ children }) => {
	return (
		<Wrapper>
			<ReactMarkdown
				components={{
					a: ({ node, ...props }) => (
						<a {...props} target="_blank" rel="noreferrer noopener">
							{props.children}
							<sup>
								<ExternalIcon name="external" />
							</sup>
						</a>
					)
				}}
				skipHtml={false}
			>
				{children}
			</ReactMarkdown>
		</Wrapper>
	);
};
